import React from 'react';

const NotFoundPage = () => (
  <div className="NotFoundPage" data-testid="NotFoundPage">
    NotFoundPage page
  </div>
);

NotFoundPage.propTypes = {};

NotFoundPage.defaultProps = {};

export default NotFoundPage;
